import { Component, EventEmitter, Output } from '@angular/core';
import { DateTime } from 'luxon';
import { finalize } from 'rxjs/operators';
import { CurrentUserService } from 'src/app/utils';
import { LegalTerms } from 'src/app/utils/cargo-driver-check-in-model';
import { LegalTermsNotificationMode } from 'src/app/utils/cargo-driver-check-in-model/legal-terms';
import { LegalTermsService } from 'src/app/utils/cargo-driver-check-in-service/services';
import { LegalTermsSite } from 'src/environments/environment';
import { AcceptanceLegalTermsResult } from './models/acceptance-legal-terms-result';

@Component({
    selector: 'app-acceptance-legal-terms',
    templateUrl: './acceptance-legal-terms.component.html',
    styleUrls: ['./acceptance-legal-terms.component.scss'],
    standalone: false
})
export class AcceptanceLegalTermsComponent {

  public LegalTermsNotificationMode = LegalTermsNotificationMode;
  public saving: boolean = false;
  public applicableDate: string;
  public timezone: string;
  public legalTerms: LegalTerms;

  @Output() action = new EventEmitter<AcceptanceLegalTermsResult>();

  get isMandatory(): boolean {
    return !!this.legalTerms?.isMandatory();
  }

  get cancelLabel(): string {
    return this.isMandatory ? 'Decline' : 'Dismiss';
  }

  get termsOfUseUrl(): string {
    return LegalTermsSite.terms_of_use;
  }

  get privacyPolicyUrl(): string {
    return LegalTermsSite.privacy_policy;
  }

  constructor(
    private currentUserService: CurrentUserService,
    private legalTermsService: LegalTermsService
  ) { }

  init(legalTerms: LegalTerms): void {
    this.legalTerms = legalTerms;
    this.applicableDate = this.getApplicableDate();
  }

  accept(): void {
    if (this.saving) {
      return;
    }

    this.saving = true;

    this.legalTermsService.acceptLegalTerms()
      .pipe(
        finalize(() => {
          this.action.emit(AcceptanceLegalTermsResult.ACCEPTED);
        })
      )
      .subscribe();
  }

  cancel(): void {
    const result = this.isMandatory ? AcceptanceLegalTermsResult.DECLINED : AcceptanceLegalTermsResult.DISMISSED;
    this.action.emit(result);
  }

  private getApplicableDateTime(): DateTime {
    const timestamp: number = this.legalTerms.ltm_applicable_date;
    const timezone = this.currentUserService.instantTimezone;

    return timezone
      ? DateTime.fromMillis(timestamp, { zone: timezone })
      : DateTime.fromMillis(timestamp);
  }

  private getApplicableDate(): string {
    return this.getApplicableDateTime().toFormat('LLL d yyyy');
  }

}
